import { togglePasswordPreview } from "./partials/input";
import { accordionToggle } from "./partials/accordion";
import { elementToggle } from "./partials/element-toggle";

("use strict");
(function ($) {
    $(document).ready(function () {
        $(".js-nav-button").on("click", function () {
            $(this).toggleClass("nav__button--open");
            $(".js-nav-box").toggleClass("nav__box--open");
        });

        // Initialize Select2 for specializations
        function initSpecializationSelect2() {
            $(".js-specialization-input").each(function() {
                var $select = $(this);

                // Get specializations from data attribute
                var specializationsData = $select.data('specializations');

                // If data attribute exists and has new data, update options
                if (specializationsData && Array.isArray(specializationsData)) {
                    // Store currently selected values
                    var selectedValues = $select.val() || [];

                    // Clear existing options
                    $select.empty();

                    // Add new options from data attribute
                    specializationsData.forEach(function(spec) {
                        var $option = $('<option></option>')
                            .attr('value', spec.id)
                            .text(spec.name);

                        // Restore selection if it was previously selected
                        if (selectedValues.indexOf(String(spec.id)) !== -1 ||
                            selectedValues.indexOf(spec.id) !== -1) {
                            $option.prop('selected', true);
                        }

                        $select.append($option);
                    });
                }

                // Destroy existing Select2 instance if it exists
                if ($select.data('select2')) {
                    $select.select2('destroy');
                }

                // Initialize Select2
                $select.select2({
                    placeholder: "Претражите",
                    closeOnSelect: false,
                    width: "100%",
                    minimumResultsForSearch: 0,
                });
            });
        }

        initSpecializationSelect2();

        $(".js-specialization-input").on("select2:open", function () {
            const $select = $(this);
            const $dropdown = $(".select2-container--open .select2-dropdown");

            if ($select.prop("multiple")) {
                $dropdown.addClass("select2-dropdown--multi");
            } else {
                $dropdown.addClass("select2-dropdown--single");
            }
        });

        function updateSelect2Text($select) {
            const texts = $select
                .find("option:selected")
                .map(function () {
                    return $(this).text();
                })
                .get()
                .join(", ");

            $select
                .next(".select2")
                .find(".select2-selection__rendered")
                .text(texts || "Претражите");
        }

        updateSelect2Text($(".js-specialization-input"));

        $(".js-specialization-input").on("change", function () {
            updateSelect2Text($(this));
        });

        $(".js-specialization-input").on("select2:open", function () {
            const $select = $(this);
            if (!$select.prop("multiple")) return;

            const select2 = $select.data("select2");

            setTimeout(() => {
                const $dropdown = $(
                    ".select2-container--open .select2-dropdown"
                );
                if (!$dropdown.length) return;

                if ($dropdown.find(".custom-dropdown-search").length) return;

                const $searchWrapper = $(
                    '<div class="select2-search select2-search--dropdown custom-dropdown-search"></div>'
                );
                const $input = $(
                    '<input type="search" class="select2-search__field" placeholder="Претражите...">'
                );

                $searchWrapper.append($input);
                $dropdown.prepend($searchWrapper);

                $input.on("input", function () {
                    const term = $(this).val();
                    select2.trigger("query", { term });
                });

                $input.trigger("focus");
            }, 0);
        });

        // Password Preview Toggle
        togglePasswordPreview();

        // Header nav toggle
        elementToggle(".js-hrp-nav", ".js-hrp-nav-trigger", "active", "slide");

        // Acordion toggle
        accordionToggle(
            ".js-application-trigger",
            ".js-application",
            ".js-application-body",
            ".js-application-chevron"
        );

        // Tooltip toggle
        elementToggle(
            ".js-form-tooltip",
            ".js-form-info-btn",
            "active",
            "fade"
        );

        // Custom select
        const selects = $(".js-select");
        selects.each((index, select) => {
            const $select = $(select);
            if ($.fn.selectric) {
                $select.selectric({
                    disableOnMobile: false,
                    nativeOnMobile: false,
                });
            } else {
                console.error("Selectric is NOT loaded!");
            }
        });

        $(".js-datepicker").flatpickr({
            locale: "sr", // Serbian Cyrillic
            dateFormat: "d.m.Y",
            disableMobile: true,
            onReady: function (selectedDates, dateStr, instance) {
                // Ensure Flatpickr has fully loaded
                if (!instance.calendarContainer) {
                    console.error("Flatpickr: calendarContainer not found.");
                    return;
                }

                const minDateValue =
                    instance.input.getAttribute("data-min-date");
                if (minDateValue) {
                    instance.set(
                        "minDate",
                        minDateValue === "today" ? new Date() : minDateValue
                    );
                }

                // Find the default month container
                const monthContainer =
                    instance.calendarContainer.querySelector(
                        ".flatpickr-months"
                    );
                if (!monthContainer) {
                    console.error(
                        "Flatpickr: .flatpickr-months container not found."
                    );
                    return;
                }

                // Hide the native select dropdown
                const nativeSelect = monthContainer.querySelector(
                    ".flatpickr-monthDropdown-months"
                );
                if (nativeSelect) {
                    nativeSelect.style.display = "none";
                }

                // Create a custom dropdown
                let customDropdown = document.createElement("div");
                customDropdown.classList.add("custom-month-dropdown");

                // Button to show the dropdown
                let selectedMonth = document.createElement("button");
                selectedMonth.classList.add("selected-month");
                selectedMonth.innerText =
                    instance.l10n.months.longhand[instance.currentMonth];
                customDropdown.appendChild(selectedMonth);

                // Store reference on instance for reuse
                instance._customSelectedMonthButton = selectedMonth;

                // Create dropdown menu
                let dropdownMenu = document.createElement("div");
                dropdownMenu.classList.add("custom-month-options");

                // Populate dropdown with months
                instance.l10n.months.longhand.forEach((month, index) => {
                    let monthOption = document.createElement("div");
                    monthOption.classList.add("custom-month-option");
                    monthOption.innerText = month;
                    monthOption.dataset.month = index;

                    // Change month on selection
                    monthOption.addEventListener("click", function () {
                        instance.changeMonth(
                            parseInt(this.dataset.month) - instance.currentMonth
                        );
                        dropdownMenu.classList.remove("show");
                    });

                    dropdownMenu.appendChild(monthOption);
                });

                customDropdown.appendChild(dropdownMenu);
                monthContainer.appendChild(customDropdown); // Append the custom dropdown

                // Show dropdown on click
                selectedMonth.addEventListener("click", function (e) {
                    e.stopPropagation();
                    dropdownMenu.classList.toggle("show");
                });

                // Close dropdown when clicking outside
                document.addEventListener("click", function () {
                    dropdownMenu.classList.remove("show");
                });
            },
            onMonthChange: function (selectedDates, dateStr, instance) {
                // Update custom month label
                if (instance._customSelectedMonthButton) {
                    instance._customSelectedMonthButton.innerText =
                        instance.l10n.months.longhand[instance.currentMonth];
                }
            },
            onYearChange: function (selectedDates, dateStr, instance) {
                // Also update label on year change if needed
                if (instance._customSelectedMonthButton) {
                    instance._customSelectedMonthButton.innerText =
                        instance.l10n.months.longhand[instance.currentMonth];
                }
            },
        });

        $(".js_submit_contact_form").on("click", function (e) {
            e.preventDefault();
            let me = $(this);
            if (me.hasClass("currently_clicked")) {
                return false;
            }
            me.addClass("currently_clicked");

            let form = $(".js_contact_form");
            let messageContent = form.find('textarea[name="message"]').val();

            // Clear previous errors
            form.find(".form__error-message").hide();
            form.find(".form__group").removeClass("has-error");

            if (messageContent.trim() === "") {
                form.find('textarea[name="message"]')
                    .closest(".form__group")
                    .addClass("has-error");
                form.find('textarea[name="message"]')
                    .closest(".form__group")
                    .find(".form__error-message")
                    .show();
                me.removeClass("currently_clicked");
                return false;
            }

            $.ajax({
                url: hcp_ajax.ajax_url,
                type: "POST",
                data: {
                    action: "hcp_send_contact_message",
                    form_data: {
                        message: messageContent,
                    },
                },
                success: function (response) {
                    if (
                        typeof response.status !== "undefined" &&
                        response.status === "ok"
                    ) {
                        $("header").before(
                            '<div class="alert-message alert-message--success js-alert-message"><p>Порука је успешно послата. Хвала вам на контакту!</p><button class="js-alert-message-close" aria-label="Zatvori poruku!"></button></div>'
                        );
                        setTimeout(function () {
                            $(".js-alert-message").remove();
                        }, 3000);
                        $(".js_submit_contact_form").prop("disabled", true);
                        form.find('textarea[name="message"]').val("");
                        me.removeClass("currently_clicked");
                        return false;
                    } else if (typeof response.error !== "undefined") {
                        form.find('textarea[name="message"]')
                            .closest(".form__group")
                            .addClass("has-error");
                        form.find('textarea[name="message"]')
                            .closest(".form__group")
                            .find(".form__error-message")
                            .text("Грешка: " + response.error)
                            .show();
                    }
                    me.removeClass("currently_clicked");
                },
                error: function (xhr, status, error) {
                    form.find('textarea[name="message"]')
                        .closest(".form__group")
                        .addClass("has-error");
                    form.find('textarea[name="message"]')
                        .closest(".form__group")
                        .find(".form__error-message")
                        .text(
                            "Дошло је до грешке приликом слања поруке. Покушајте поново."
                        )
                        .show();
                    me.removeClass("currently_clicked");
                },
            });
        });

        $("#send_application_date_change_form").on(
            "click",
            ".js_change_proposed_dates_btn, .js_decline_add_dates_btn",
            function (e) {
                e.preventDefault();
                let clickedBtn = $(this);
                let dateChangeForm = clickedBtn.closest("form");

                if (clickedBtn.hasClass("js_decline_add_dates_btn")) {
                    if (
                        dateChangeForm.find("input[name='new_date']:checked")
                            .length
                    ) {
                        dateChangeForm
                            .find("input[name='new_date']:checked")
                            .prop("checked", false);
                    }
                    dateChangeForm
                        .find("input[name='reject_all_dates']")
                        .val("yes");
                } else {
                    dateChangeForm
                        .find("input[name='reject_all_dates']")
                        .val("no");
                }

                if (
                    (dateChangeForm.find("input[name='new_date']:checked")
                        .length &&
                        dateChangeForm
                            .find("input[name='reject_all_dates']")
                            .val() === "no") ||
                    (dateChangeForm.find("input[name='new_date']:checked")
                        .length === 0 &&
                        dateChangeForm
                            .find("input[name='reject_all_dates']")
                            .val() === "yes")
                ) {
                    dateChangeForm.submit();
                }
            }
        );

        // Profession cards functionality
        $(".form__card").on("click", function (e) {
            // Don't handle clicks on sub-options
            if ($(e.target).closest(".js-medical-sub-options").length < 0) {
                return;
            }

            const card = $(this);
            const radioInput = card.find('input[name="user_type"]');

            // Uncheck all user_type radio inputs
            $('input[name="user_type"]').prop("checked", false);
            $(".form__card").removeClass("selected");

            // Check the clicked radio input
            radioInput.prop("checked", true);
            card.addClass("selected");

            // Trigger change event to handle sub-options
            radioInput.trigger("change");
        });

        // Initialize medical sub-options visibility
        const medicalCard = $(".js-form-card-medical");
        const subOptions = medicalCard.find(".js-medical-sub-options");
        const medicalStaffRadio = medicalCard.find(
            'input[name="user_type"][value="medical_staff"]'
        );

        if (medicalStaffRadio.is(":checked")) {
            subOptions.addClass("show");
        } else {
            subOptions.removeClass("show");
        }

        // Handle radio input changes
        $('.form__card input[type="radio"]').on("change", function () {
            const radioInput = $(this);
            const card = radioInput.closest(".form__card");
            const name = radioInput.attr("name");

            // Remove selected class from all cards with same name
            $(`input[name="${name}"]`)
                .closest(".form__card")
                .removeClass("selected");

            // Add selected class to current card
            if (radioInput.is(":checked")) {
                card.addClass("selected");
            }

            // Show/hide medical sub-options
            if (name === "user_type") {
                const medicalCard = $(".js-form-card-medical");
                const subOptions = medicalCard.find(".js-medical-sub-options");
                const registerBtn = $(".js-register-continue");

                registerBtn.removeAttr("disabled");

                if (radioInput.val() === "medical_staff") {
                    subOptions.addClass("show");
                } else {
                    subOptions.removeClass("show");
                    // Uncheck doctor/technician selection
                    medicalCard
                        .find('input[name="medical_subtype"]')
                        .prop("checked", false);
                }
            }
        });

        // Form validation before submission
        $("#profession_selection_form").on("submit", function (e) {
            const medicalStaffRadio = $(
                'input[name="user_type"][value="medical_staff"]'
            );
            const doctorRadio = $('input[name="medical_subtype"]');

            if (medicalStaffRadio.is(":checked")) {
                if (!doctorRadio.is(":checked")) {
                    e.preventDefault();
                    return false;
                }
            }
        });

        // Reusable password validation function
        function validatePassword(
            passwordValue,
            emailValue,
            showAlert = false
        ) {
            if (!passwordValue) return { isValid: true, message: "" };

            // Check password length
            if (passwordValue.length < 8) {
                return {
                    isValid: false,
                    message: "Лозинка мора да има најмање 8 карактера.",
                };
            }
            // Check for at least one lowercase letter (Latin + Cyrillic)
            else if (!/[a-zа-ш]/.test(passwordValue)) {
                return {
                    isValid: false,
                    message: "Лозинка мора да садржи најмање једно мало слово.",
                };
            }
            // Check for at least one uppercase letter (Latin + Cyrillic)
            else if (!/[A-ZА-Ш]/.test(passwordValue)) {
                return {
                    isValid: false,
                    message:
                        "Лозинка мора да садржи најмање једно велико слово.",
                };
            }
            // Check for at least one digit
            else if (!/[0-9]/.test(passwordValue)) {
                return {
                    isValid: false,
                    message: "Лозинка мора да садржи најмање једну цифру.",
                };
            }
            // Check that password doesn't contain email
            else if (
                emailValue &&
                passwordValue.toLowerCase().includes(emailValue.toLowerCase())
            ) {
                return {
                    isValid: false,
                    message: "Лозинка не сме да садржи емаил адресу.",
                };
            }

            return { isValid: true, message: "" };
        }

        // General form validation function
        function validateForm(form) {
            let isValid = true;

            // Clear previous error styling
            $(".form__group").removeClass("has-error");

            // Validate all required fields
            $(form)
                .find(".required")
                .each(function () {
                    const field = $(this);
                    let value = field.val();

                    // Handle different field types
                    if (field.is("select[multiple]")) {
                        // For multi-select, check if any options are selected
                        value =
                            value && value.length > 0 ? value.join(",") : "";
                    } else if (typeof value === "string") {
                        value = value.trim();
                    }

                    if (!value) {
                        isValid = false;
                        field.closest(".form__group").addClass("has-error");
                    }

                    // Special validation for email fields
                    if (field.is('input[type="email"]') && value) {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(value)) {
                            isValid = false;
                            field
                                .closest(".form__group")
                                .addClass("has-error--email");
                        }
                    }
                });

            // Comprehensive password validation using reusable function
            // Only validate password if it's provided (for update forms, password is optional)
            const passwordField = $(form).find('input[name="password"]');
            const passwordValue = passwordField.val();
            const emailField = $(form).find('input[name="email"]');
            const emailValue = emailField.val();

            // Only validate password if it's not empty
            if (passwordValue && passwordValue.trim() !== "") {
                const passwordValidation = validatePassword(
                    passwordValue,
                    emailValue
                );
                if (!passwordValidation.isValid) {
                    isValid = false;
                    passwordField
                        .closest(".form__group")
                        .addClass("has-error--password");
                    passwordField
                        .closest(".form__group")
                        .find(".form__error-message--password")
                        .text(passwordValidation.message)
                        .show();
                }

                // Password confirmation validation - only if password is provided
                const confirmPasswordField = $(form).find(
                    'input[name="confirm_password"]'
                );
                const confirmPasswordValue = confirmPasswordField.val();

                if (passwordValue !== confirmPasswordValue) {
                    isValid = false;
                    confirmPasswordField
                        .closest(".form__group")
                        .addClass("has-error--confirm-password");
                }
            }

            return isValid;
        }

        // Remove error styling on focus/change
        $(document).on("focus change", ".required", function () {
            $(this)
                .closest(".form__group")
                .removeClass(
                    "has-error has-error--email has-error--password has-error--confirm-password"
                );
        });

        // Clear password validation errors on input
        $(document).on(
            "input",
            'input[name="password"], input[name="confirm_password"]',
            function () {
                const field = $(this);
                const fieldName = field.attr("name");

                // Clear error styling
                field
                    .closest(".form__group")
                    .removeClass(
                        "has-error--password has-error--confirm-password"
                    );

                // Hide error messages
                if (fieldName === "password") {
                    field
                        .closest(".form__group")
                        .find(".form__error-message--password")
                        .hide();
                } else if (fieldName === "confirm_password") {
                    field
                        .closest(".form__group")
                        .find(".form__error-message--confirm-password")
                        .hide();
                }
            }
        );

        // Registration form validation
        $("#registration_form").on("submit", function (e) {
            if (!validateForm(this)) {
                e.preventDefault();
            }
        });

        $("#update_account_form").on("submit", function (e) {
            if (!validateForm(this)) {
                e.preventDefault();
            }
        });

        // Profile update form validation
        // $('#update_account_form').on('submit', function(e) {
        //     let isValid = true;
        //
        //     // Clear previous errors
        //     $('.form__error-message').hide();
        //     $('.form__group').removeClass('has-error');
        //
        //     // Get form values
        //     let firstName = $('input[name="first_name"]').val().trim();
        //     let lastName = $('input[name="last_name"]').val().trim();
        //     let email = $('input[name="email"]').val().trim();
        //     let password = $('input[name="password"]').val();
        //     let confirmPassword = $('input[name="confirm_password"]').val();
        //
        //     // Validate required fields
        //     if (!firstName) {
        //         showFieldError('first_name', 'Поље "Име" је обавезно.');
        //         isValid = false;
        //     }
        //
        //     if (!lastName) {
        //         showFieldError('last_name', 'Поље "Презиме" је обавезно.');
        //         isValid = false;
        //     }
        //
        //     if (!email) {
        //         showFieldError('email', 'Поље "Емаил адреса" је обавезно.');
        //         isValid = false;
        //     } else if (!isValidEmail(email)) {
        //         showFieldError('email', 'Унесите исправну емаил адресу.');
        //         isValid = false;
        //     }
        //
        //     // Validate password if provided
        //     if (password) {
        //         let passwordValidation = validatePassword(password, email);
        //         if (!passwordValidation.isValid) {
        //             showFieldError('password', passwordValidation.message);
        //             isValid = false;
        //         }
        //
        //         if (password !== confirmPassword) {
        //             showFieldError('confirm_password', 'Лозинке се не поклапају.');
        //             isValid = false;
        //         }
        //     }
        //
        //     // Validate medical staff fields if applicable
        //     let specializationsField = $('select[name="specializations[]"]');
        //     let institutionField = $('select[name="institution"]');
        //
        //     // Check if medical staff fields exist in DOM (meaning user is medical staff)
        //     if (specializationsField.length > 0) {
        //         let specializations = specializationsField.val();
        //         if (!specializations || specializations.length === 0) {
        //             showFieldError('specializations', 'Поље "Специјализација" је обавезно.');
        //             isValid = false;
        //         }
        //     }
        //
        //     if (institutionField.length > 0) {
        //         let institution = institutionField.val();
        //         if (!institution) {
        //             showFieldError('institution', 'Поље "Здравствена установа" је обавезно.');
        //             isValid = false;
        //         }
        //     }
        //
        //     // If validation passes, submit the form
        //     if (isValid) {
        //         // Form will submit normally to PHP
        //         return true;
        //     } else {
        //         // Prevent form submission if validation fails
        //         e.preventDefault();
        //         return false;
        //     }
        // });

        // Helper function to show field errors
        // function showFieldError(fieldName, message) {
        // let field = $('input[name="' + fieldName + '"], select[name="' + fieldName + '[]"], select[name="' + fieldName + '"]');
        // let formGroup = field.closest('.form__group');
        //     formGroup.addClass('has-error');
        //
        //     let errorElement = formGroup.find('.form__error-message');
        //     if (errorElement.length) {
        //         errorElement.text(message).show();
        //     }
        //
        //     // Prevent browser from scrolling to the field
        //     return false;
        // }

        // Helper function to validate email
        // function isValidEmail(email) {
        //     let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        //     return emailRegex.test(email);
        // }

        // Clear errors on input for profile update form
        // $('#update_account_form input, #update_account_form select').on('input change', function() {
        //     let formGroup = $(this).closest('.form__group');
        //     formGroup.removeClass('has-error');
        //     formGroup.find('.form__error-message').hide();
        // });

        // Duty application term selection functionality
        // Handle term card selection (use event delegation)
        $(document).on("click", ".term-card", function () {
            // Find the closest proposed-terms container
            let termsContainer = $(this).closest(".proposed-terms");

            // Remove selected class from all term cards in this container
            termsContainer.find(".term-card").removeClass("selected");

            // Add selected class to clicked card
            $(this).addClass("selected");

            // Enable the confirm button for this application
            let confirmButton = termsContainer.find(".js-confirm-term");
            confirmButton
                .prop("disabled", false)
                .removeClass("button--disabled");
        });

        // Handle confirm term button (use event delegation)
        $(document).on("click", ".js-confirm-term", function () {
            let button = $(this);

            if (button.hasClass("currently_clicked")) {
                return false;
            }

            // Find the closest proposed-terms container
            let termsContainer = button.closest(".proposed-terms");
            let selectedCard = termsContainer.find(".term-card.selected");

            if (selectedCard.length === 0) {
                console.log("Молимо изаберите један од предложених термина.");
                return;
            }

            let applicationId = button.data("application-id");
            let selectedTermId = selectedCard.data("date-id");

            button.addClass("currently_clicked");

            let ajaxData = {
                action: "hcp_confirm_duty_term",
                application_id: applicationId,
                offered_date_id: selectedTermId,
                user_email: hcp_ajax.user_email,
            };

            $.ajax({
                url: hcp_ajax.ajax_url,
                type: "POST",
                data: ajaxData,
                success: function (response) {
                    if (response.success) {
                        // Reload page - success message will be shown from session
                        location.reload();
                    }
                    button.removeClass("currently_clicked");
                },
                error: function () {
                    button.removeClass("currently_clicked");
                },
            });
        });

        // Handle reject terms button (use event delegation)
        $(document).on("click", ".js-reject-terms", function () {
            let button = $(this);

            if (button.hasClass("currently_clicked")) {
                return false;
            }

            let applicationId = button.data("application-id");
            button.addClass("currently_clicked");

            $.ajax({
                url: hcp_ajax.ajax_url,
                type: "POST",
                data: {
                    action: "hcp_reject_duty_terms",
                    application_id: applicationId,
                    user_email: hcp_ajax.user_email,
                },
                success: function (response) {
                    if (response.success) {
                        // Reload page - success message will be shown from session
                        location.reload();
                    }
                    button.removeClass("currently_clicked");
                },
                error: function () {
                    button.removeClass("currently_clicked");
                },
            });
        });
    });

    // Clear errors when user starts typing
    $("#available_from, #available_to").on("click", function () {
        $(this).closest(".form-group").removeClass("has-error");
    });

    $("#passport_number").on("input", function () {
        $(this).closest(".form-group").removeClass("has-error");
    });

    // Duty Application Form - Date Range Picker
    if ($("#calendar-widget").length) {
        initDateRangePicker();
    }

    // Duty Application Form - AJAX Submission
    $("#duty-application-form").on("submit", function (e) {
        e.preventDefault();

        let form = $(this);
        let submitButton = form.find("#submit-application");

        // Clear previous errors
        form.find(".form__error-message").hide();
        form.find(".has-error").removeClass("has-error");

        // Basic validation
        let availableFrom = form.find("#available_from").val();
        let availableTo = form.find("#available_to").val();
        let passportNumber = form.find("#passport_number").val();
        let hasErrors = false;

        if (!availableFrom || !availableTo) {
            form.find(".date-range-picker")
                .closest(".form-group")
                .addClass("has-error");
            hasErrors = true;
        }

        if (!passportNumber) {
            form.find("#passport_number")
                .closest(".form-group")
                .addClass("has-error");
            hasErrors = true;
        }

        if (hasErrors) {
            return false;
        }

        // Disable submit button
        submitButton.prop("disabled", true).text("Шаље се...");

        // Prepare form data
        let formData = {
            action: "hcp_submit_duty_application",
            available_from: availableFrom,
            available_to: availableTo,
            passport_number: passportNumber,
            additional_info: form.find("#additional_info").val(),
            user_email: hcp_ajax.user_email,
        };

        $.ajax({
            url: hcp_ajax.ajax_url,
            type: "POST",
            data: formData,
            success: function (response) {
                if (response.success) {
                    // Redirect to my-account page
                    window.location.href = hcp_ajax.home_url + "/hld-nalog/";
                } else {
                    // Show error message above form
                    form.before(
                        '<div class="alert alert-danger">Дошло је до грешке: ' +
                            (response.message || "Покушајте поново.") +
                            "</div>"
                    );
                    setTimeout(function () {
                        $(".alert").remove();
                    }, 3000);
                }
            },
            error: function () {
                // Show error message above form
                form.before(
                    '<div class="alert alert-danger">Дошло је до грешке приликом слања пријаве. Покушајте поново.</div>'
                );
                setTimeout(function () {
                    $(".alert").remove();
                }, 3000);
            },
            complete: function () {
                submitButton.prop("disabled", false).text("Пошаљите пријаву");
            },
        });
    });

    function initDateRangePicker() {
        let calendarWidget = $("#calendar-widget");
        let fromInput = $("#available_from");
        let toInput = $("#available_to");

        let currentDate = new Date();
        let currentMonth = currentDate.getMonth();
        let currentYear = currentDate.getFullYear();

        let selectedStartDate = null;
        let selectedEndDate = null;

        function renderCalendar() {
            let firstDay = new Date(currentYear, currentMonth, 1);
            let lastDay = new Date(currentYear, currentMonth + 1, 0);
            let startDate = new Date(firstDay);
            // Convert to Serbian week format (Monday = 0, Sunday = 6)
            let dayOfWeek = firstDay.getDay();
            let serbianDayOfWeek = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
            startDate.setDate(startDate.getDate() - serbianDayOfWeek);

            let calendarHTML = `
                <div class="calendar-header">
                    <div class="month-year">${getMonthName(
                        currentMonth
                    )} ${currentYear}</div>
                    <div class="nav-buttons">
                        <button type="button" class="prev-month"></button>
                        <button type="button" class="next-month"></button>
                    </div>
                </div>
                <div class="calendar-grid">
                    <div class="day-header">П</div>
                    <div class="day-header">У</div>
                    <div class="day-header">С</div>
                    <div class="day-header">Ч</div>
                    <div class="day-header">П</div>
                    <div class="day-header">С</div>
                    <div class="day-header">Н</div>
            `;

            for (let i = 0; i < 42; i++) {
                let date = new Date(startDate);
                date.setDate(startDate.getDate() + i);

                let isCurrentMonth = date.getMonth() === currentMonth;
                let isToday = isSameDate(date, new Date());
                let isSelected = false;
                let isInRange = false;
                let isRangeStart = false;
                let isRangeEnd = false;

                if (selectedStartDate && selectedEndDate) {
                    isInRange =
                        date >= selectedStartDate && date <= selectedEndDate;

                    isRangeStart = isSameDate(date, selectedStartDate);
                    isRangeEnd = isSameDate(date, selectedEndDate);

                    isSelected = isRangeStart || isRangeEnd;
                } else if (selectedStartDate) {
                    isRangeStart = isSameDate(date, selectedStartDate);
                    isSelected = isRangeStart;
                }

                const selected = isSelected ? "selected" : "";
                const inRange = isInRange ? " in-range" : "";
                const rangeStart = isRangeStart ? " range-start" : "";
                const rangeEnd = isRangeEnd ? " range-end" : "";
                const cm = !isCurrentMonth ? " disabled" : "";

                calendarHTML += `
                    <button class="day-cell ${
                        selected + inRange + rangeStart + rangeEnd + cm
                    }"
                    data-date="${formatDate(date)}"
                    data-timestamp="${date.getTime()}">
                        ${date.getDate()}
                    </button>
                `;
            }

            calendarHTML += `
                </div>
                <div class="calendar-actions">
                    <button type="button" class="button button--secondary button--calendar btn-cancel">Одустани</button>
                    <button type="button" class="button button--primary button--calendar btn-apply" disabled>Примени</button>
                </div>
            `;

            calendarWidget.html(calendarHTML);
        }

        function getMonthName(month) {
            const months = [
                "Јануар",
                "Фебруар",
                "Март",
                "Април",
                "Мај",
                "Јун",
                "Јул",
                "Август",
                "Септембар",
                "Октобар",
                "Новембар",
                "Децембар",
            ];
            return months[month];
        }

        function formatDate(date) {
            let day = String(date.getDate()).padStart(2, "0");
            let month = String(date.getMonth() + 1).padStart(2, "0");
            let year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }

        function isSameDate(date1, date2) {
            return (
                date1.getDate() === date2.getDate() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getFullYear() === date2.getFullYear()
            );
        }

        function updateInputs() {
            if (selectedStartDate && selectedEndDate) {
                fromInput.val(formatDate(selectedStartDate));
                toInput.val(formatDate(selectedEndDate));
                calendarWidget.find(".btn-apply").prop("disabled", false);
            } else if (selectedStartDate) {
                fromInput.val(formatDate(selectedStartDate));
                toInput.val("");
                calendarWidget.find(".btn-apply").prop("disabled", true);
            }
        }

        // Event handlers
        calendarWidget.on("click", ".prev-month", function () {
            currentMonth--;
            if (currentMonth < 0) {
                currentMonth = 11;
                currentYear--;
            }
            renderCalendar();
        });

        calendarWidget.on("click", ".next-month", function () {
            currentMonth++;
            if (currentMonth > 11) {
                currentMonth = 0;
                currentYear++;
            }
            renderCalendar();
        });

        calendarWidget.on("click", ".day-cell:not(.disabled)", function () {
            let timestamp = parseInt($(this).data("timestamp"));
            let date = new Date(timestamp);


            if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
                // Start new selection
                selectedStartDate = date;
                selectedEndDate = null;
            } else if (selectedStartDate && !selectedEndDate) {
                // Complete selection
                if (date < selectedStartDate) {
                    selectedEndDate = selectedStartDate;
                    selectedStartDate = date;
                } else {
                    selectedEndDate = date;
                }
            }

            renderCalendar();
            updateInputs();
        });

        calendarWidget.on("click", ".btn-cancel", function () {
            selectedStartDate = null;
            selectedEndDate = null;
            fromInput.val("");
            toInput.val("");
            renderCalendar();
            $(".date-range-picker").hide();
            $(".js-date-input-trigger span").html("");
            $(".js-duty-application-btn").prop("disabled", true);
        });

        calendarWidget.on("click", ".btn-apply", function () {
            if (selectedStartDate && selectedEndDate) {
                $(".date-range-picker").hide();
                $(".js-date-input-trigger span").text(
                    selectedStartDate.toLocaleDateString("en-GB") +
                        "-" +
                        selectedEndDate.toLocaleDateString("en-GB")
                );
            }
        });

        // Show calendar when clicking on date inputs
        $(".js-date-input-trigger").on("click", function () {
            $(".date-range-picker").toggle();
        });

        // Initial render
        renderCalendar();
        $(".date-range-picker").hide();
    }

    // Autocomplete Input Component
    function initAutocompleteInput(selector, options = []) {
        const $input = $(selector);
        if (!$input.length) return;

        const $wrapper = $input.parent();
        const $dropdown = $('<div class="autocomplete-dropdown"></div>');
        $wrapper.append($dropdown);

        let filteredOptions = options;
        let isOpen = false;

        // Filter options based on input value
        function filterOptions(value) {
            if (!value) {
                filteredOptions = options;
            } else {
                const searchValue = value.toLowerCase();
                filteredOptions = options.filter((opt) =>
                    opt.toLowerCase().includes(searchValue)
                );
            }
            renderDropdown();
        }

        // Render dropdown
        function renderDropdown() {
            $dropdown.empty();

            if (filteredOptions.length > 0) {
                filteredOptions.forEach((option) => {
                    const $option = $(
                        '<div class="autocomplete-option">' + option + "</div>"
                    );
                    $option.on("click", function () {
                        $input.val(option);
                        $dropdown.hide();
                        isOpen = false;
                        $input.trigger("change");
                    });
                    $dropdown.append($option);
                });
            } else {
                $dropdown.html(
                    '<div class="autocomplete-option autocomplete-no-results">Нема резултата</div>'
                );
            }
        }

        // Handle input change
        $input.on("input", function () {
            const value = $(this).val();
            filterOptions(value);
            if (value && !isOpen) {
                $dropdown.show();
                isOpen = true;
            }
        });

        // Handle focus
        $input.on("focus", function () {
            const value = $(this).val();
            filterOptions(value);
            $dropdown.show();
            isOpen = true;
        });

        // Handle blur
        $input.on("blur", function () {
            setTimeout(() => {
                if (!$dropdown.is(":hover") && !$input.is(":focus")) {
                    $dropdown.hide();
                    isOpen = false;
                }
            }, 200);
        });

        // Keep dropdown open on hover
        $dropdown.on("mouseenter", function () {
            isOpen = true;
        });

        // Initial render
        renderDropdown();
        $dropdown.hide();
    }

    // Initialize autocomplete for city and institution fields
    function initRegistrationAutocomplete() {
        let citiesData = [];
        let institutionsData = [];

        // Check if registration data is available (for registration page)
        if (typeof window.hldwp_registration_data !== "undefined") {
            citiesData = window.hldwp_registration_data.cities || [];
            institutionsData =
                window.hldwp_registration_data.institutions || [];
        }
        // Check if profile update data is available (for profile update page)
        else if (typeof window.hldwp_profile_update_data !== "undefined") {
            citiesData = window.hldwp_profile_update_data.cities || [];
            institutionsData =
                window.hldwp_profile_update_data.institutions || [];
        }

        // Initialize city autocomplete with preloaded data
        if (citiesData && citiesData.length > 0) {
            initAutocompleteInput('input[name="city"]', citiesData);
        }

        // Initialize institution autocomplete with preloaded data
        if (institutionsData && institutionsData.length > 0) {
            // All institution fields are already input elements in templates, no conversion needed
            initAutocompleteInput(
                'input[name="institution"]',
                institutionsData
            );
        }
    }

    // Initialize on window load to ensure data is available
    // window.load fires after all inline scripts are executed, so no timeout is needed
    $(window).on("load", function () {
        initRegistrationAutocomplete();
    });

    // Custom confirmation popup handler
    function showConfirmationPopup(options) {
        return new Promise(function(resolve, reject) {
            const $popup = $("#hld-confirmation-popup");
            const $title = $("#hld-confirmation-popup-title");
            const $message = $("#hld-confirmation-popup-message");
            const $confirmBtn = $(".js-confirmation-popup-confirm");
            const $cancelBtn = $(".js-confirmation-popup-cancel");
            const $overlay = $(".js-confirmation-popup-close");

            // Check if popup elements exist
            if (!$popup.length || !$title.length || !$message.length || !$confirmBtn.length || !$cancelBtn.length) {
                // Fallback to browser confirm if popup doesn't exist
                const confirmed = confirm(options.message || "Да ли сте сигурни?");
                resolve(confirmed);
                return;
            }

            // Set title and message
            $title.text(options.title || "Потврда");
            $message.text(options.message || "Да ли сте сигурни?");

            // Show popup
            $popup.addClass("hld-confirmation-popup--active").css("display", "flex");

            // Handle confirm button
            function handleConfirm() {
                $popup.removeClass("hld-confirmation-popup--active").css("display", "none");
                cleanup();
                resolve(true);
            }

            // Handle cancel button
            function handleCancel() {
                $popup.removeClass("hld-confirmation-popup--active").css("display", "none");
                cleanup();
                resolve(false);
            }

            // Cleanup event listeners
            function cleanup() {
                $confirmBtn.off("click", handleConfirm);
                $cancelBtn.off("click", handleCancel);
                $overlay.off("click", handleCancel);
                $(document).off("keydown", handleEscape);
            }

            // Handle ESC key
            function handleEscape(e) {
                if (e.key === "Escape" || e.keyCode === 27) {
                    handleCancel();
                }
            }

            // Attach event listeners
            $confirmBtn.on("click", handleConfirm);
            $cancelBtn.on("click", handleCancel);
            $overlay.on("click", handleCancel);
            $(document).on("keydown", handleEscape);
        });
    }

    // Handle delete user button click for membership applications page
    function initDeleteUserButton() {
        $(".js-delete-user-btn").on("click", function (e) {
            e.preventDefault();

            const $button = $(this);
            const nonce = $button.data("nonce");
            const confirmMessage = $button.data("confirm-message") ||
                "Да ли сте сигурни да желите да обришете ваш налог и почнете регистрацију из почетка?";
            const confirmTitle = $button.data("confirm-title") || "Потврда брисања";

            // Show custom confirmation popup
            showConfirmationPopup({
                title: confirmTitle,
                message: confirmMessage
            }).then(function(userConfirmed) {
                if (!userConfirmed) {
                    // User clicked "Откажи" (Cancel) - do nothing
                    return false;
                }

                // User clicked "Потврди" (Confirm) - proceed with deletion
                $button.prop("disabled", true).text("Обрада...");

                $.ajax({
                    url:
                        typeof hcp_ajax !== "undefined" && hcp_ajax.ajax_url
                            ? hcp_ajax.ajax_url
                            : "/wp-admin/admin-ajax.php",
                    type: "POST",
                    data: {
                        action: "hldwp_delete_user_and_logout",
                        nonce: nonce,
                    },
                    success: function (response) {
                        if (response.success) {
                            // Redirect to registration page
                            if (response.redirect_url) {
                                window.location.href = response.redirect_url;
                            } else {
                                // Use home_url from hcp_ajax if available, otherwise construct from current location
                                const homeUrl =
                                    typeof hcp_ajax !== "undefined" &&
                                    hcp_ajax.home_url
                                        ? hcp_ajax.home_url
                                        : window.location.protocol +
                                          "//" +
                                          window.location.host;
                                window.location.href =
                                    homeUrl + "/hld-registracija/";
                            }
                        } else {
                            alert(
                                response.message ||
                                    "Дошло је до грешке приликом брисања налога."
                            );
                            $button
                                .prop("disabled", false)
                                .text("Региструјте се поново");
                        }
                    },
                    error: function () {
                        alert(
                            "Дошло је до грешке приликом комуникације са сервером."
                        );
                        $button
                            .prop("disabled", false)
                            .text("Региструјте се поново");
                    },
                });
            });
        });
    }

    function checkRequired(formId, buttonClass) {
        let allFilled = true;

        $(`#${formId} input.required`).each(function () {
            if ($(this).val().trim() === "") {
                allFilled = false;
            }
        });

        $(`.${buttonClass}`).prop("disabled", !allFilled);
    }

    $("#contact_form").on(
        "input change",
        "input[required], select[required], textarea[required]",
        function () {
            checkRequired("contact_form", "js_submit_contact_form");
        }
    );

    checkRequired("contact_form", "js_submit_contact_form");

    $("#duty-application-form").on(
        "input change",
        "input[required], select[required], textarea[required], .required",
        function () {
            checkRequired("duty-application-form", "js-duty-application-btn");
        }
    );

    $(document).on("click", "#duty-application-form .btn-apply", function () {
        checkRequired("duty-application-form", "js-duty-application-btn");
    });

    checkRequired("duty-application-form", "js-duty-application-btn");

    $(document).on("click", ".js-alert-message-close", function () {
        $(this).parent().remove();
    });

    function checkScrollbar() {
        const container = document.querySelector(".custom-scrollbar");
        // Check if element exists before accessing its properties
        if (!container) {
            return;
        }
        // Check if scrollHeight is greater than clientHeight
        const isScrollable = container.scrollHeight > container.clientHeight;

        if (isScrollable) {
            container.classList.add("has-scrollbar");
        } else {
            container.classList.remove("has-scrollbar");
        }
    }

    checkScrollbar();

    // Initialize delete user button handler
    $(document).ready(function () {
        initDeleteUserButton();
    });
})(jQuery);
